<template>
  <div class="pl-chat-search-messages-area">
    <v-text-field label="Поиск по сообщениям" append-icon="search" single-line />

    <ul class="pl-search-result-list">
      <li class="pl-search-result-list__item" />
    </ul>
  </div>
</template>

<script>
export default {
  name: 'PlChatSearchMessages',
}
</script>

<style scoped lang="scss">
.pl-chat-search-messages-area {
  padding: 1rem 2rem;
}
.pl-search-result-list {
  padding: 0;
  list-style-type: none;
}
</style>
